import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

const Breadcrumbs = ({ breadcrumbs, currentName }) => {
	if (currentName === undefined) return null;

	return (
		<>
			<div id="breadcrumbs">
				{breadcrumbs.map((item, index) => (
					<div className="bread-item" key={index}>
						<Link key={index} to={item.eurl}>
							{item.nm}
						</Link>
					</div>
				))}
				<div className="bread-item">{currentName}</div>
			</div>
		</>
	);
};

Breadcrumbs.propTypes = {
	breadcrumbs: PropTypes.array,
	currentName: PropTypes.string
};

export default Breadcrumbs;
